export default __webpack_public_path__ + "static/media/014-lifeguard tower.e0ea2a10.svg";